export default class SerbiaUtil {
    constructor(client) {
        this.client = client
    }

    async nsbSearch(params) {
        return await this.services("GET", "nbs/search", {params})
    }

    async getReceiptFromUrl(url, source) {
        return await this.services("POST", "receipt/crawl", {
            data: {
                url,
                source
            }
        })
    }

    async getContoList() {
        return await this.services("GET", "conto")
    }

    async services(method, endpoint, params) {
        return this.request(method, `services/${endpoint}`, params)
    }

    async request(method, endpoint, params) {
        return await this.client.request({
            method: method,
            url: "/karadjordje/" + endpoint,
            ...params
        })
    } 
}